export const checkState = state => {
  if (!state) return '';
  if (typeof state === 'object') return state.label;
  return state;
};



// WEBPACK FOOTER //
// ./src/utils/checkState.js